import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { EmpathySection } from '../components/EmpathySection';
import { FramingSection } from '../components/FramingSection';
import { WhatIsSection } from '../components/WhatIsSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { ResultsSection } from '../components/ResultsSection';
import { IncludesSection } from '../components/IncludesSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { AuthorSection } from '../components/AuthorSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { DisclaimerSection } from '../components/DisclaimerSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-cream-50 overflow-x-hidden" data-id="element-209">
      <HeroSection data-id="element-210" />
      <EmpathySection data-id="element-211" />
      <FramingSection data-id="element-212" />
      <WhatIsSection data-id="element-213" />
      <ForWhoSection data-id="element-214" />
      <ResultsSection data-id="element-215" />
      <IncludesSection data-id="element-216" />
      <HowItWorksSection data-id="element-217" />
      <AuthorSection data-id="element-218" />
      <PricingSection data-id="element-219" />
      <FAQSection data-id="element-220" />
      <FinalCTASection data-id="element-221" />
      <DisclaimerSection data-id="element-222" />
      <Footer data-id="element-223" />
    </main>;
}